import { h } from '../pragma.mjs';

export default () => {

    return (
    <div>
        
        <gov-tiles role="list" columns="2" id="karty">

                <gov-tile role="listitem" href="#" id="rozcestnikZapisyTile">
                    <p>Chci požádat o změnu práva, změnu na pozemku, zápis stavby, zápis poznámky apod.</p>
                    <h3 slot="title">Zápisy do katastru nemovitostí</h3>
                <gov-icon type="complex" name="my-filing" slot="icon"></gov-icon>
            </gov-tile>

                <gov-tile role="listitem" href="#" id="rozcestnikUdajeTile">
                    <p>Chci získat výpis z listu vlastnictví, kopii katastrální mapy, údaje o nemovitostech, o změnách mých nemovitostí atd.</p>
                    <h3 slot="title">Údaje katastru a zeměměřictví</h3>
                <gov-icon type="complex" name="info-list" slot="icon"></gov-icon>
            </gov-tile>

        </gov-tiles>
    </div>
    )
}